"use strict";

exports.__esModule = true;
exports.normalizeSize = void 0;

var normalizeSize = function normalizeSize(size) {
  if (typeof size === "number") return size + "px";
  return "" + size;
};

exports.normalizeSize = normalizeSize;